/**
 * Site configuration and subdomain detection.
 * Main: jackyli.dev / localhost:3000
 * Discord: discord.jackyli.dev / discord.localhost:3000
 * AWS: aws.jackyli.dev / aws.localhost:3000
 * Riot: riot.jackyli.dev / riot.localhost:3000
 */

const PRODUCTION_MAIN_URL = 'https://jackyli.dev';
const PRODUCTION_DISCORD_URL = 'https://discord.jackyli.dev';
const PRODUCTION_AWS_URL = 'https://aws.jackyli.dev';
const PRODUCTION_RIOT_URL = 'https://riot.jackyli.dev';

export const DISCORD_SUBDOMAIN_PREFIX = 'discord.';
export const AWS_SUBDOMAIN_PREFIX = 'aws.';
export const RIOT_SUBDOMAIN_PREFIX = 'riot.';

/** Routes that only exist on the main domain */
export const MAIN_ONLY_PATHS = ['/styles'];

/** Routes that only exist on the discord subdomain */
export const DISCORD_ONLY_PATHS = [
  '/getting-started',
  '/about',
  '/skills',
  '/education',
  '/contact',
  '/work',
  '/timeline',
  '/personal',
  '/projects',
  '/blog',
  '/notes',
  '/card-art',
  '/commit-logs',
  '/featured-project',
  '/guide',
  '/category/about-me',
  '/category/experience',
  '/category/contact-me',
  '/category/fun',
  '/category/help',
  '/404',
];

export const getLayoutFromHost = () => {
  const hostname = window.location.hostname;
  if (hostname.startsWith(DISCORD_SUBDOMAIN_PREFIX)) return 'discord';
  if (hostname.startsWith(AWS_SUBDOMAIN_PREFIX)) return 'aws';
  if (hostname.startsWith(RIOT_SUBDOMAIN_PREFIX)) return 'riot';
  return 'main';
};

export const isDiscordHost = () => getLayoutFromHost() === 'discord';
export const isAwsHost = () => getLayoutFromHost() === 'aws';
export const isRiotHost = () => getLayoutFromHost() === 'riot';
export const isMainHost = () => getLayoutFromHost() === 'main';

export const getMainUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//localhost${port}`;
  }
  return PRODUCTION_MAIN_URL;
};

export const getDiscordUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//discord.localhost${port}`;
  }
  return PRODUCTION_DISCORD_URL;
};

export const getAwsUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//aws.localhost${port}`;
  }
  return PRODUCTION_AWS_URL;
};

export const getRiotUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//riot.localhost${port}`;
  }
  return PRODUCTION_RIOT_URL;
};

export const getSiteUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return window.location.origin;
  }
  const layout = getLayoutFromHost();
  if (layout === 'discord') return PRODUCTION_DISCORD_URL;
  if (layout === 'aws') return PRODUCTION_AWS_URL;
  if (layout === 'riot') return PRODUCTION_RIOT_URL;
  return PRODUCTION_MAIN_URL;
};

export const getLayoutUrl = (layoutId) => {
  if (layoutId === 'discord') return getDiscordUrl();
  if (layoutId === 'aws') return getAwsUrl();
  if (layoutId === 'riot') return getRiotUrl();
  return getMainUrl();
};
